import { api } from '@services';

import Setting, { ISetting, ISettingApiModel } from '@models/Setting.model';

const getSettings = async (): Promise<ISetting[]> => {
  const { data: settings } = await api.get<ISettingApiModel[]>('/settings');

  return Setting.arrayFromApiModel(settings);
};

export { getSettings };
